import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=56c6318c&scoped=true&"
import script from "./Validation.vue?vue&type=script&lang=js&"
export * from "./Validation.vue?vue&type=script&lang=js&"
import style0 from "./Validation.vue?vue&type=style&index=0&id=56c6318c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6318c",
  null
  
)

export default component.exports